import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Grid,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import { Cancel } from '@material-ui/icons';
import moment from 'moment';
import { ITechnicalRoomHistory } from '../interfaces';

const useStyles = makeStyles({
  table: {
    '& thead': {
      '& th': {
        fontWeight: 600,
        backgroundColor: '#FDD7E7',
      },
    },

    '& tbody': {
      '& tr': {
        '& td': {
          backgroundColor: '#FAFAFA',
          transition: 'background-color 200ms',
        },
        '&:hover': {
          '& td': {
            backgroundColor: '#f5f5f5',
          },
        },
      },
    },
  },
  loader: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    zIndex: 1000,
  },
});

interface IProps {
  loading: boolean;
  technicalRoomHistoryItem: ITechnicalRoomHistory | null;
  onClose(): void;
}

const TechnicalRoomHistoryItem: React.FC<IProps & DialogProps> = ({
  open,
  technicalRoomHistoryItem,
  loading,
  onClose,
}) => {
  // Styles
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="body">
      <DialogTitle>
        <b>Информация о действиии</b>
      </DialogTitle>

      {loading && (
        <Box className={classes.loader}>
          <CircularProgress />
        </Box>
      )}

      <DialogContent dividers>
        <Grid container spacing={3}>
          {technicalRoomHistoryItem && (
            <Grid item xs={12}>
              <Typography component="h3" variant="h6" gutterBottom>
                Основная информация
              </Typography>

              <TableContainer component={Paper} variant="outlined">
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell>ID пользователя</TableCell>
                      <TableCell>Пользователь</TableCell>
                      <TableCell>Тип действия</TableCell>
                      <TableCell>Дата и время</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {technicalRoomHistoryItem && (
                      <TableRow key={technicalRoomHistoryItem.technicalRoomHistoryId}>
                        <TableCell>{technicalRoomHistoryItem.createUserId}</TableCell>
                        <TableCell>{technicalRoomHistoryItem.createUserName}</TableCell>
                        <TableCell>{technicalRoomHistoryItem.logActionType}</TableCell>
                        <TableCell>{moment(technicalRoomHistoryItem.createTimestamp).format('DD/MM/YYYY')}</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          )}

          <Grid item xs={12}>
            <Typography component="h3" variant="h6" gutterBottom>
              Действия
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TableContainer component={Paper} variant="outlined">
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Поле</TableCell>
                        <TableCell>Старое значение</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {technicalRoomHistoryItem?.oldValues.map(({ technicalRoomHistoryValueId, field, value }) => (
                        <TableRow key={technicalRoomHistoryValueId}>
                          <TableCell>{field}</TableCell>
                          <TableCell>{value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>

              <Grid item xs={6}>
                <TableContainer component={Paper} variant="outlined">
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Поле</TableCell>
                        <TableCell>Новое значение</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {technicalRoomHistoryItem?.newValues.map(({ technicalRoomHistoryValueId, field, value }) => (
                        <TableRow key={technicalRoomHistoryValueId}>
                          <TableCell>{field}</TableCell>
                          <TableCell>{value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={onClose} startIcon={<Cancel />}>
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TechnicalRoomHistoryItem;
